<template>
  <div>
    <!-- Form element that submits all the data in the form to Firebase using the submitData method -->
    <form @submit.prevent="$emit('form-submit', form, day)">
      <!-- Add form fields here, wrapped in a div with a class of field -->
      <div class="field">
        <label for="time-to-bed">
          <span>Time went to bed (lights out):</span>
          <input
            type="time"
            name="time-to-bed"
            v-model="form.timeToBed"
            required
            @invalid="invalidTime"
            @input="clearValidity"
          />
        </label>
      </div>

      <div class="field">
        <label for="time-to-sleep">
          <span>How long it took to fall asleep:</span>
          <input
            type="number"
            name="time-to-sleep"
            min="0"
            v-model="form.timeToSleep"
            required
          />
        </label>
      </div>

      <div class="field">
        <label for="awakenings">
          <span>Number of awakenings after initial sleep onset:</span>
          <input
            type="number"
            name="awakenings"
            min="0"
            v-model="form.awakenings"
            required
          />
        </label>
      </div>

      <div class="field">
        <label for="awake-time">
          <span>
            In total, how long were you awake due to awakenings after first
            falling asleep:
          </span>
          <select name="awake-time" v-model="form.awakeTime" required>
            <option value="0">0min</option>
            <option value="5">5min</option>
            <option value="10">10min</option>
            <option value="15">15min</option>
            <option value="30">30min</option>
            <option value="45">45min</option>
            <option value="60">60min</option>
            <option value="75">75min</option>
            <option value="90">90min</option>
          </select>
        </label>
      </div>

      <div class="field">
        <label for="wake-up-time">
          <span>Morning wake-up time:</span>
          <input
            type="time"
            name="wake-up-time"
            v-model="form.wakeUpTime"
            required
            @invalid="invalidTime"
            @input="clearValidity"
          />
        </label>
      </div>

      <div class="field">
        <label for="out-bed-time">
          <span>Time out of bed (lights on):</span>
          <input
            type="time"
            name="out-bed-time"
            v-model="form.outBedTime"
            required
            @invalid="invalidTime"
            @input="clearValidity"
          />
        </label>
      </div>

      <div class="field">
        <p>Sleep quality:</p>
        <Radios
          name="sleep-quality"
          :entry="existingEntry"
          @store-number="storeSleepQuality"
          data="sleepQuality"
          amount="11"
        />
      </div>

      <div class="field">
        <p>Refreshed on awakening:</p>
        <Radios
          name="refreshed"
          :entry="existingEntry"
          @store-number="storeRefreshed"
          data="refreshed"
          amount="11"
        />
      </div>

      <div class="field">
        <label for="daytime-naps-amount">
          <span>Daytime naps:</span>
          <input
            type="number"
            name="daytime-naps-amount"
            min="0"
            v-model="form.daytimeNapsAmount"
            required
          />
        </label>
      </div>

      <div class="field">
        <label for="daytime-naps-duration">
          <span>Total duration of daytime naps:</span>
          <input
            type="number"
            name="daytime-naps-duration"
            min="0"
            v-model="form.daytimeNapsDuration"
            required
          />
        </label>
      </div>

      <div class="field">
        <button class="button button--standard" type="submit">
          <span v-if="day.edit">Update</span>
          <span v-else>Log your sleep!</span>
        </button>
        <button
          class="button button--danger"
          v-if="day.edit"
          @click.prevent="$emit('cancel-edit', day)"
        >
          Cancel
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { differenceInMinutes } from "date-fns";
import Sleep from "../../../mixins/modules/sleep.js";
import Radios from "@/components/Radios.vue";

export default {
  name: "Form",
  mixins: [Sleep],
  props: ["existingEntry", "day"],
  components: { Radios },
  methods: {
    invalidTime({ target }) {
      target.setCustomValidity("Please enter a valid time.");
    },
    clearValidity({ target }) {
      target.setCustomValidity("");
    },
    storeSleepQuality(level) {
      this.form.sleepQuality = level;
    },
    storeRefreshed(level) {
      this.form.refreshed = level;
    },
  },
  data() {
    return {
      form: {
        // Add form field data here. This data will be submitted to Firestore and
        // should match the v-model values from your form fields.
        timeToBed: this.existingEntry ? this.existingEntry.data.timeToBed : "",

        timeToSleep: this.existingEntry
          ? this.existingEntry.data.timeToSleep
          : 0,

        awakenings: this.existingEntry ? this.existingEntry.data.awakenings : 0,

        awakeTime: this.existingEntry ? this.existingEntry.data.awakeTime : 0,

        wakeUpTime: this.existingEntry
          ? this.existingEntry.data.wakeUpTime
          : "",

        outBedTime: this.existingEntry
          ? this.existingEntry.data.outBedTime
          : "",

        sleepQuality: this.existingEntry
          ? this.existingEntry.data.sleepQuality
          : 0,

        refreshed: this.existingEntry ? this.existingEntry.data.refreshed : 0,

        daytimeNapsAmount: this.existingEntry
          ? this.existingEntry.data.daytimeNapsAmount
          : 0,

        daytimeNapsDuration: this.existingEntry
          ? this.existingEntry.data.daytimeNapsDuration
          : 0,
      },
    };
  },
};
</script>

<style>
button {
  margin-right: 1rem;
}
</style>
